import { render, staticRenderFns } from "./ClassTableFormWithoutModal.vue?vue&type=template&id=53a46ebf"
import script from "./ClassTableFormWithoutModal.vue?vue&type=script&lang=js"
export * from "./ClassTableFormWithoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports